export class UserCreationBody {
  constructor(
    public givenName: string,
    public surname: string,
    public mail: string,
    public password: string,
    public hubspotOwnerId: string,
    public companyIds: string[],
  ) {}

  public isValid(): boolean {
    return (
      !!this.givenName || !!this.surname || !!this.mail || !!this.hubspotOwnerId
    );
  }

  public assertValid(): void | Error {
    if (!this.isValid()) {
      throw new Error(
        'user requires "givenName", "surname", "hubspotOwnerId" and "mail"',
      );
    }
  }
}
